import { isEmpty } from "lodash";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { appointmentHistoryReports } from "../../report/appointmentHistoryReports";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

// Posición de cada documento de la consulta en el reporte (optionReport).
export const HISTORY_REPORT = {
  IMAGES: 0,
  LABORATORY: 1,
  LICENSE: 2,
  REFERRAL: 3,
  PRESCRIPTION: 4,
  QUOTATION: 5,
};

const isMedicalResultRecord = (item = {}) => {
  const hasFiles = Array.isArray(item?.files) && item.files.length > 0;
  const hasResultDate = Boolean((item?.resultDate || "").toString().trim());
  const hasExamLabel = Boolean((item?.examLabel || "").toString().trim());
  return hasFiles || hasResultDate || hasExamLabel;
};

// Solicitudes de examen ("imageExam" o "laboratoryExam") que se imprimen; los
// registros de resultados no forman parte de la indicación.
export const getExamRequestRows = (rows = [], examKey) =>
  (rows || []).filter(
    (row) =>
      Boolean(Number(row?.[`${examKey}Id`] || row?.[examKey]?.id || 0)) &&
      !isMedicalResultRecord(row),
  );

// `onlyReports` limita la impresión a los documentos indicados (HISTORY_REPORT).
export default function handleShowReportAppointmentHistory({
  appointmentHistoryImages = [],
  appointmentHistoryLaboratory = [],
  appointmentHistoryLicenses = [],
  appointmentHistoryMedicalPrecription = {},
  appointmentHistoryReferral = {},
  quotations = {},
  medicalStaff = [],
  patient = [],
  ars = {},
  companyInfo = null,
  onlyReports = null,
}) {
  let dataJob = [
    appointmentHistoryImages,
    appointmentHistoryLaboratory,
    appointmentHistoryLicenses,
    appointmentHistoryReferral,
    appointmentHistoryMedicalPrecription?.precriptionDetails,
    quotations?.quotationsDetails,
  ];

  console.log("quotations", quotations);

  dataJob.forEach((item, index) => {
    if (isEmpty(item) || (onlyReports && !onlyReports.includes(index))) return;

    const products = [];
    let product = [];
    const table = [];
    let headerCurrent = "";
    let createAt = "";
    // Número del documento agrupado (el primero de la lista); los separados usan el suyo.
    let groupCode;

    const addTable = (textValue) =>
      table.push({
        text: textValue || "",
        fontSize: 11,
        bold: true,
        alignment: "center",
      });

    const addProducts = (props) => product.push({ ...props, fontSize: 11 });

    const addProductsOption2 = (textValue) =>
      product.push({
        text: textValue || "",
        fontSize: 11,
        margin: [0, 10, 0, 0],
      });

    const showReport = (productDetail = null, documentCode = groupCode) => {
      pdfMake
        .createPdf(
          appointmentHistoryReports(
            {
              dataRecipe: {
                date: appointmentHistoryMedicalPrecription?.date,
                expiryDate: appointmentHistoryMedicalPrecription?.expiryDate,
                prescriptionNumber:
                  appointmentHistoryMedicalPrecription?.prescriptionNumber,
              },
              medicalStaff,
              patient,
              ars,
              headerCurrent,
              dataQuotations: {
                code: quotations?.code,
                date: quotations?.date,
                expirationDate: quotations?.expirationDate,
              },
              dataLicenses: {
                code: appointmentHistoryLicenses?.code,
                date: appointmentHistoryLicenses?.date,
                days: appointmentHistoryLicenses?.days,
              },
              optionReport: index,
              companyInfo,
              documentCode,
            },
            { products: productDetail ? [[productDetail]] : products, table },
            createAt
          )
        )
        .open();
    };

    switch (index) {
      case 0:
        const imagingExamRows = getExamRequestRows(item, "imageExam");

        if (isEmpty(imagingExamRows)) break;

        headerCurrent = "Estudios de Imagen";
        addTable("Estudio de Imagen");
        createAt = imagingExamRows[0]?.createAt || "";
        for (const imageDetail of imagingExamRows) {
          product = [];
          if (imageDetail?.imageExam?.productType?.prescriptionSeparate) {
            showReport(
              { text: imageDetail.imageExam?.name || "", fontSize: 11 },
              imageDetail?.code || null,
            );
          } else {
            groupCode = groupCode || imageDetail?.code;
            addProducts({ text: imageDetail.imageExam?.name || "" });
            products.push(product);
          }
        }
        break;

      case 1:
        const laboratoryExamRows = getExamRequestRows(item, "laboratoryExam");

        if (isEmpty(laboratoryExamRows)) break;

        headerCurrent = "Exámenes de Laboratorio";
        addTable("Exámen de Laboratorio");
        createAt = laboratoryExamRows[0]?.createAt || "";
        for (const laboratoryDetail of laboratoryExamRows) {
          product = [];
          if (
            laboratoryDetail?.laboratoryExam?.productType?.prescriptionSeparate
          ) {
            showReport(
              { text: laboratoryDetail?.laboratoryExam?.name || "", fontSize: 11 },
              laboratoryDetail?.code || null,
            );
          } else {
            groupCode = groupCode || laboratoryDetail?.code;
            addProducts({
              text: laboratoryDetail?.laboratoryExam?.name || "",
            });
            products.push(product);
          }
        }
        break;

      case 2:
        if (!item?.licensesTypes?.id) break;
        headerCurrent = "Licencia Medica";
        addProductsOption2("Dias de Licencia: " + item.days + " dias" || "");
        addProductsOption2(
          "Descripcion: " + item.licensesTypes.description || ""
        );
        addProductsOption2("Justificacion: " + item.description || "");
        products.push(product);
        break;

      case 3:
        if (!item?.speciality?.id) break;
        headerCurrent = "Referimiento Médico";
        groupCode = item?.code;
        createAt = item?.createAt || "";
        addProductsOption2("Medico: " + item.medicalName || "");
        addProductsOption2("Especialidad: " + item.speciality?.name || "");
        addProductsOption2("Observacion: " + item.observation || "");
        products.push(product);
        break;

      case 4:
        headerCurrent = "Prescripción de Medicamentos";
        addTable("Producto");
        addTable("Cantidad");
        addTable("Frecuencia");
        addTable("Dias");
        addTable("Total");
        addTable("Nota");
        for (const medicineDetail of item) {
          product = [];
          addProducts({ text: medicineDetail?.medicine?.name || "" });
          addProducts({ text: medicineDetail?.quantity || "" });
          addProducts({
            text:
              medicineDetail?.frecuency +
                " " +
                medicineDetail?.frecuencyDaysHours || "",
          });
          addProducts({
            text:
              medicineDetail?.duration +
                " " +
                medicineDetail?.durationDaysWeeksMonths || "",
          });
          addProducts({ text: medicineDetail?.totalDosis || "" });
          addProducts({ text: medicineDetail?.doctorNote || "" });
          products.push(product);
        }
        break;
      case 5:
        headerCurrent = "Cotizaciones de Servicios";
        addTable("Procedimiento");
        addTable("Cantidad");
        addTable("Precio");
        addTable("Cobertura");
        addTable("Diferencia");
        addTable("Valor");
        let totalCoverage = 0;
        let totalDifference = 0;
        let totalValue = 0;
        for (const quotationsDetails of item) {
          totalCoverage += parseFloat(quotationsDetails?.insuredCoverage) || 0;
          totalDifference +=
            parseFloat(quotationsDetails?.consultoryDifferent) || 0;
          totalValue +=
            parseFloat(quotationsDetails?.consultoryDifferent) *
              quotationsDetails?.quantity || 0;
          product = [];
          addProducts({
            text: quotationsDetails?.product?.name || "",
          });
          addProducts({
            text: quotationsDetails?.quantity || "",
          });
          addProducts({
            text: quotationsDetails?.consultoryFee
              ? `$${quotationsDetails.consultoryFee.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`
              : "",
            alignment: "right",
          });
          addProducts({
            text: quotationsDetails?.insuredCoverage
              ? `$${quotationsDetails.insuredCoverage.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`
              : "",
            alignment: "right",
          });
          addProducts({
            text: quotationsDetails?.consultoryDifferent
              ? `$${quotationsDetails.consultoryDifferent.toLocaleString(
                  "en-US",
                  { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                )}`
              : "",
            alignment: "right",
          });
          addProducts({
            text: quotationsDetails?.consultoryDifferent
              ? `$${(
                  quotationsDetails.consultoryDifferent *
                  quotationsDetails?.quantity
                ).toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`
              : "",
            alignment: "right",
          });
          products.push(product);
        }

        product = [];

        addProducts({
          text: "",
          border: [false, false, false, false],
        });
        addProducts({
          text: "",
          border: [false, false, false, false],
        });
        addProducts({
          text: "Total:",
          bold: true,
        });
        addProducts({
          text: `$${totalCoverage.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`,
          alignment: "right",
          bold: true,
        });
        addProducts({
          text: `$${totalDifference.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`,
          alignment: "right",
          bold: true,
        });
        addProducts({
          text: `$${totalValue.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`,
          alignment: "right",
          bold: true,
        });
        products.push(product);
        break;
      default:
    }

    !isEmpty(products) && showReport();
  });
}
